module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av723-c7735197b49bbfd9cf35ae36c3911a7a.jpg";